'use strict';

/*

  Example:

  {
    help: 'my help',
    hasError: true,
    id: 'password-tip'
  }

*/

function getHelpBlock(opts) {
  return {
    tag: 'span',
    attrs: {
      className: {
        'help-block': true,
        'error-block': opts.hasError
      },
      // aria support
      id: opts.id,
      role: 'tooltip'
    },
    children: opts.help
  };
}

module.exports = getHelpBlock;




/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getHelpBlock.js
 ** module id = 1069
 ** module chunks = 0
 **/